var map = {
	"./avoidedcost.svg": "4202",
	"./big-data.svg": "d1ff",
	"./calendar.svg": "9c65",
	"./calib.svg": "163c",
	"./called.svg": "d001",
	"./checklist.svg": "73a6",
	"./contracts.svg": "00e9",
	"./dash.svg": "3cae",
	"./equips.svg": "2d85",
	"./import.svg": "4fa5",
	"./patchnotes.svg": "ab7f",
	"./reports.svg": "0cc4",
	"./servOrder.svg": "9838",
	"./standchecklist.svg": "f4b6",
	"./standequip.svg": "ed73",
	"./stock.svg": "7124",
	"./supplier.svg": "a83d",
	"./tasks.svg": "d3a1",
	"./tools.svg": "0035",
	"./users.svg": "3086"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af87";